import styled from "styled-components"
import { useDispatch } from "react-redux"
import { IoCreateOutline } from "react-icons/io5";
import create from "../../images/svg/create-chat.svg"
import { useSelector } from "react-redux";
import { getSupportChatById, setArchiveChat, setMessageRead, setSelectedChat } from "../../features/messages/messageSlice";
import moment from "moment";
import { useEffect, useState } from "react";
import { MdOutlineArchive } from "react-icons/md";
import { GrLinkPrevious } from "react-icons/gr";
import { MdArrowBack } from "react-icons/md";


const Container = styled.div`
    width: 270px;
    max-height: 90vh;
    min-height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};
    margin-right: 20px;

    .message-kamyoon{
        background: var(--color-main);
        width: 100%;
        height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        position: relative;
        padding-inline: 20px;
        svg{
            cursor: pointer;
            width: 25px;
            height: 25px;
            color: #fff;
        }
        span{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-lg);
            background-color: #fff;
            color: var(--color-main);
            padding: 3px;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
            color: #fff;
            display: flex;
            align-items: center;
            gap: 5px;
        }
        img{
            right: 10px;
            cursor: pointer;
            width: 20px;
        }
    }

    .titles-list{
        display: flex;
        flex-direction: column;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        max-height: 65vh;
        overflow-y: auto;
        &::-webkit-scrollbar {
            height: 8px;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.secondaryTextColor};
            /* border-radius: 10px; */
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        .chat-item{
            border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
            padding-block: 20px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            gap: 7px;
            position: relative;
            .chat-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                padding: 0 20px;
            }
            span{
                position: absolute;
                top: 0;
                right: 0;
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main);
                padding: 5px;
            }
            .notification{
                background-color: var(--color-main);
                color: #fff;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 5px !important;
                right: 5px !important;
            }
        }
        .chat-item:last-child{
            border-bottom: none !important;
        }
    }
    
    .date{
        font-size: var(--font-size-xs) !important;
        font-weight: var(--font-weight-md) !important;
    }
    .select-chat{
        background-color: ${({theme})=> theme.secondaryBgColor};
    }
    .dots{
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
        display: inline-block !important;
    }
`

const TabSide = () => {
    const {supportChatList, selectedChat, isArchive} = useSelector((state) => state.message)
    const dispatch = useDispatch()
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    const storageUserId = JSON.parse(storage.getItem("userId"))

    const [allRead, setAllRead] = useState(null)

    useEffect(() => {
        const unreadMessages = supportChatList?.reduce((acc, item) => {
            const unread = item?.supportChatMessages?.filter(item => item.isRead === false && item.creatorUserId !== storageUserId)
            return acc + unread.length
        },0)  

        setAllRead(unreadMessages)
    }, [supportChatList])

    const clickMessage = (item) => {
        const filterUnread = item?.supportChatMessages?.filter(item => item.isRead === false && item.creatorUserId !== storageUserId)
        const unreadToArray = filterUnread?.map(item => item.id)
        
        dispatch(setSelectedChat(item)); 
        dispatch(getSupportChatById(item.id))
        dispatch(setMessageRead({values:unreadToArray}))
    }
    
    return (
    <Container>
        <div className="message-kamyoon">
            {isArchive ? 
                <MdArrowBack onClick={() => dispatch(setArchiveChat())} />
            :
                <MdOutlineArchive onClick={() => dispatch(setArchiveChat())} />
            }
            
            <p>Mesajlar {allRead > 0 && <span>{allRead}</span>}</p>
            <img onClick={() => dispatch(setSelectedChat(null))} src={create} alt="" />
        </div>
        <div className="titles-list">
            {
                supportChatList?.length > 0 ?
                supportChatList.map(item => (
                    <div key={item.id} onClick={() => clickMessage(item)} className={`chat-item ${selectedChat?.id === item?.id ? "select-chat" : ""}`}>
                        {item?.supportChatMessages?.filter(item => item?.isRead === false && item?.creatorUserId !== storageUserId)?.length > 0 &&
                            <span className="notification">
                                {item?.supportChatMessages?.filter(item => item?.isRead === false && item.creatorUserId !== storageUserId)?.length}
                            </span>
                        }
                        {item.isClosed && 
                            <span>Sonlandırılmış</span>
                        }
                        {"0e1bb90c-f5bb-4c65-b749-25e18d8dc9a0" === rld &&
                            <div className="chat-text name">
                                {item.creatorUser?.adSoyadUnvan}
                            </div>
                        }
                        <div className="chat-text dots">
                            {item.supportChatMessages[item?.supportChatMessages?.length - 1]?.message}
                        </div>
                        <div className="chat-text date">
                            {/* {moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).format("DD.MM.YYYY HH:mm")} */}
                            {
                                moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).isSame(new Date(), 'day') 
                                ? moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).format("HH:mm")
                                : moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).isSame(moment().subtract(1, 'day'), 'day')
                                ? `Dün ${moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).format("HH:mm")}`
                                : moment(item?.supportChatMessages[item?.supportChatMessages?.length - 1]?.createdAt).format("DD.MM.YYYY HH:mm")
                            }
                        </div>
                    </div>
                ))
                :
                <div className="chat-item">
                    <div  className="chat-text">
                    {
                        isArchive ?
                        "Arşivlenmiş Mesajınız Yok."
                        :
                        "Mesajlaşma geçmişiniz boş."
                    }
                    </div>
                </div>
            }
        </div>
    </Container>
  )
}

export default TabSide